import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { BiensImmobs } from 'app/models/biensImmobs';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import { AwscontrolService, UploadResponse } from 'app/services/aws/awscontrol.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-ajouter-biens-immob',
  templateUrl: './ajouter-biens-immob.component.html',
  styleUrls: ['./ajouter-biens-immob.component.scss']
})
export class AjouterBiensImmobComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
  @ViewChild('agencySelect') agencySelect!: MatSelect;
  @ViewChild('agencySearchInput') agencySearchInput!: ElementRef;

  // Form data
  biensImmob: BiensImmobs;
  
  // File upload – single main image
  selectedFile: File | null = null;
  mainImage: string = '';       // URL of the uploaded main image
  
  // Agencies
  agenciesApp: any;
  selectedAgencyName: string = '';
  selectedAgencyId: string | null = null; // <-- store selected agency ID
  
  // Agency search functionality
  public agencySearch: string = '';
  public filteredAgencies: any[] = [];
  public allAgencies: any[] = [];
  public isAgencySelectOpen: boolean = false;
  
  // Categories
  public categoryInput: string = '';
  
  // Other
  NameAgence: any;
  idItem: any;
  idA: any;
  NameAgence1: any;
  public biens: any;

  // Upload states
  public isUploading: boolean = false;
  public uploadProgress: number = 0;

  constructor(
    private router: Router,
    public location: Location,
    private agenciesService: AgenciesService,
    private bienImmobService: BiensImmobsBiensImmobs,
    private awsService: AwscontrolService
  ) { 
    this.biensImmob = new BiensImmobs();
  }

  ngOnInit(): void {
    this.clearStoredImages();
    this.getData();
    
    this.agenciesService.getId().subscribe((data: any) => {
      this.idA = data;
      console.log('Agency ID:', this.idA);
    });
    
    this.retrieveStoredItemId();
    this.AgencyNameById();
    this.AgencyNameById1();
  }

  // Formatage du texte dans la description
  formatText(command: string): void {
    if (this.descriptionTextarea) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.biensImmob.description.substring(start, end);
      
      let formattedText = '';
      switch (command) {
        case 'bold':
          formattedText = `<strong>${selectedText}</strong>`;
          break;
        case 'italic':
          formattedText = `<em>${selectedText}</em>`;
          break;
        case 'underline':
          formattedText = `<u>${selectedText}</u>`;
          break;
      }
      
      const newText = this.biensImmob.description.substring(0, start) + 
                     formattedText + 
                     this.biensImmob.description.substring(end);
      
      this.biensImmob.description = newText;
      
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  // Gestion des catégories
  addCategory(): void {
    if (this.categoryInput && this.categoryInput.trim() !== '') {
      if (!this.biensImmob.categoryList) {
        this.biensImmob.categoryList = [];
      }
      
      if (!this.biensImmob.categoryList.includes(this.categoryInput.trim())) {
        this.biensImmob.categoryList.push(this.categoryInput.trim());
      }
      
      this.categoryInput = '';
    }
  }

  removeCategory(category: string): void {
    if (this.biensImmob.categoryList) {
      const index = this.biensImmob.categoryList.indexOf(category);
      if (index >= 0) {
        this.biensImmob.categoryList.splice(index, 1);
      }
    }
  }

  // Charger les agences avec rôle "meilleurs-biens"
  getData() {
    this.getAllAgencies();
  }

  getAllAgencies() {
    this.agenciesService.getList().subscribe({
      next: (data: any) => {
        let agencies = [];
        
        if (Array.isArray(data)) {
          agencies = data;
        } else if (data && typeof data === 'object') {
          agencies = [data];
        } else {
          agencies = [];
        }
        
        this.allAgencies = agencies
          .filter(agency => 
            agency && 
            agency.name && 
            typeof agency.name === 'string' &&
            (agency.role === 'agence-immobilieres' || agency.role === 'meilleurs-biens')
          )
          .map(agency => ({
            id: agency.id,
            name: agency.name.trim(),
            initial: this.getInitial(agency.name),
            color: this.getRandomColor()
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        
        this.filteredAgencies = [...this.allAgencies];
        
        console.log('Agences "meilleurs-biens" chargées:', this.allAgencies.length);
        
        if (this.allAgencies.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'Aucune agence disponible',
            text: 'Aucune agence avec le rôle "meilleurs-biens" n\'a été trouvée.',
            timer: 3000
          });
        }
      },
      error: (error) => {
        console.error('Erreur lors du chargement des agences:', error);
        this.allAgencies = [];
        this.filteredAgencies = [];
        Swal.fire({
          icon: 'error',
          title: 'Erreur de chargement',
          text: 'Impossible de charger la liste des agences'
        });
      }
    });
  }

  // Helper methods for agency display
  private getInitial(name: string): string {
    return name ? name.trim().charAt(0).toUpperCase() : '?';
  }

  private getRandomColor(): string {
    const colors = [
      '#FF6B6B', '#4ECDC4', '#FFD166', '#06D6A0', '#118AB2',
      '#EF476F', '#7B68EE', '#20B2AA', '#FFA07A', '#9370DB'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  // Gestion du sélecteur d'agence
  onAgencySelectOpened(): void {
    this.isAgencySelectOpen = true;
    this.agencySearch = '';
    this.filterAgencies();
    
    setTimeout(() => {
      if (this.agencySearchInput) {
        this.agencySearchInput.nativeElement.focus();
      }
    }, 100);
  }

  onAgencySelectClosed(): void {
    this.isAgencySelectOpen = false;
    this.agencySearch = '';
    this.filterAgencies();
  }

  filterAgencies(): void {
    if (!this.agencySearch || this.agencySearch.trim() === '') {
      this.filteredAgencies = [...this.allAgencies];
    } else {
      const searchTerm = this.agencySearch.toLowerCase().trim();
      this.filteredAgencies = this.allAgencies.filter(agency => {
        if (!agency || !agency.name) return false;
        return agency.name.toLowerCase().includes(searchTerm);
      });
    }
  }

  clearAgencySearch(): void {
    this.agencySearch = '';
    this.filterAgencies();
    
    if (this.agencySearchInput) {
      this.agencySearchInput.nativeElement.focus();
    }
  }

  selectAgency(agency: any): void {
    this.selectedAgencyName = agency.name;
    this.selectedAgencyId = agency.id; // <-- store agency ID
    this.agencySelect.close();
  }

  // ========== MAIN IMAGE UPLOAD (SINGLE) ==========
  selectFileimg(event: any): void {
    const file = event.target.files[0];
    if (!file) return;
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Fichier trop volumineux",
        text: "L'image dépasse la taille maximale de 5MB",
      });
      return;
    }
    
    this.selectedFile = file;
    this.uploadMainImage();
  }

  async uploadMainImage(): Promise<void> {
    if (!this.selectedFile) return;

    this.isUploading = true;
    this.uploadProgress = 0;

    Swal.fire({
      title: 'Téléchargement en cours...',
      html: 'Upload de l\'image principale',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    try {
      const folder = 'biens-immobiliers';
      const response = await this.awsService.uploadFile(this.selectedFile, folder).toPromise();
      
      Swal.close();
      
      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        this.mainImage = uploadedUrl;
        localStorage.setItem('bienImage', JSON.stringify(uploadedUrl));
        
        Swal.fire({
          icon: "success",
          title: "Image ajoutée",
          text: "L'image principale a été téléchargée avec succès",
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        throw new Error(response.error || 'Upload failed');
      }
    } catch (err: any) {
      console.error('Error uploading main image:', err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Erreur de téléchargement",
        text: "Une erreur est survenue lors du téléchargement de l'image",
      });
    } finally {
      this.isUploading = false;
      this.uploadProgress = 0;
      this.selectedFile = null;
    }
  }

  async removeMainImage(): Promise<void> {
    if (!this.mainImage) return;

    const result = await Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer cette image?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    });

    if (result.isConfirmed) {
      try {
        await this.awsService.deleteFile(this.mainImage).toPromise();
        console.log('Image deleted from AWS:', this.mainImage);
      } catch (error) {
        console.warn('Could not delete image from AWS:', error);
      }
      
      this.mainImage = '';
      localStorage.removeItem('bienImage');
      
      Swal.fire({
        icon: "success",
        title: "Image supprimée",
        text: "L'image a été supprimée avec succès",
        timer: 2000,
        showConfirmButton: false
      });
    }
  }

  clearStoredImages(): void {
    localStorage.removeItem('bienImage');
    this.mainImage = '';
  }

  // Agency methods
  retrieveStoredItemId() {
    const storedItemId = localStorage.getItem('storedItemId');
    this.idItem = storedItemId;
    console.log('Stored Item ID:', this.idItem);
  }

  AgencyNameById() {
    if (this.idA) {
      this.agenciesService.getAgencieById(this.idA).subscribe((data: any) => {
        this.NameAgence = data.name;
        console.log('Agency Name by ID:', this.NameAgence);
      });
    }
  }

  AgencyNameById1() {
    if (this.idItem) {
      this.agenciesService.getAgencieById(this.idItem).subscribe((data: any) => {
        this.NameAgence1 = data.name;
        console.log('Agency Name 1:', this.NameAgence1);
      });
    }
  }

  // Form submission
  validateYouTubeUrl(url: string): boolean {
    if (!url) return true;
    const youtubePattern = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubePattern.test(url);
  }

  onSubmit() {
    // Check if upload is in progress
    if (this.isUploading) {
      Swal.fire({
        icon: 'warning',
        title: 'Téléchargement en cours',
        text: 'Veuillez attendre la fin du téléchargement de l\'image'
      });
      return;
    }

    // Validation
    if (!this.biensImmob.name || !this.biensImmob.description || !this.selectedAgencyName) {
      Swal.fire({
        icon: 'warning',
        title: 'Champs requis',
        text: 'Veuillez remplir tous les champs obligatoires (Nom, Description, Agence)'
      });
      return;
    }

    if (this.biensImmob.videoUrlBien && !this.validateYouTubeUrl(this.biensImmob.videoUrlBien)) {
      Swal.fire({
        icon: 'error',
        title: 'URL YouTube invalide',
        text: 'Veuillez entrer une URL YouTube valide'
      });
      return;
    }

    if (!this.mainImage) {
      Swal.fire({
        icon: 'warning',
        title: 'Image requise',
        text: 'Veuillez ajouter une image du bien'
      });
      return;
    }

    this.biens = {
      "name": this.biensImmob.name,
      "description": this.biensImmob.description,
      "prix": this.biensImmob.prix,  
      "agencyName": this.selectedAgencyName,   
      "categoryList": this.biensImmob.categoryList || [],  
      "imageUrl": this.mainImage,
      "videoUrlBien": this.biensImmob.videoUrlBien,  
      "nomCommercial": this.biensImmob.nomCommercial,
      "numCommercial": this.biensImmob.numCommercial,
      "emailCommercial": this.biensImmob.emailCommercial
      // promoTitle, promoImg, type, role removed
    };

    console.log('Data to submit:', this.biens);

    this.bienImmobService.createBiensImmobs(this.biens).subscribe(
      () => {
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Le bien immobilier a été créé avec succès",
        }).then(() => {
          this.clearStoredImages();
          // Navigate to the list of biens for the selected agency
          if (this.selectedAgencyId) {
            this.router.navigate(['/list-agence-biens', this.selectedAgencyId]);
          } else {
            // Fallback if no agency ID is available
            this.location.back();
          }
        });
      },
      (error) => {
        console.error('Error creating property:', error);
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Échec de la création du bien immobilier. Veuillez réessayer.",
        });
      }
    );
  }
}